import { render, staticRenderFns } from "./TrainingQualificationDetailsContent.vue?vue&type=template&id=004c3ae0&scoped=true"
import script from "./TrainingQualificationDetailsContent.vue?vue&type=script&lang=ts"
export * from "./TrainingQualificationDetailsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c3ae0",
  null
  
)

export default component.exports